/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Col_NameInputs */

const vi_api_keys_col_name = /** @type {(inputs: Api_Keys_Col_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên khóa`)
};

/**

* @param {Api_Keys_Col_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const api_keys_col_name = /** @type {((inputs?: Api_Keys_Col_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Col_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_api_keys_col_name(inputs)
});